import React from "react"

const LazyRenderOnView = ({
  children,
  className = "",
  rootMargin = "320px 0px",
  minHeight = 0,
  placeholder = null,
}) => {
  const containerRef = React.useRef(null)
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    if (typeof window === "undefined") return undefined

    if (!("IntersectionObserver" in window)) {
      setIsVisible(true)
      return undefined
    }

    const observer = new IntersectionObserver(entries => {
      const hasVisibleEntry = entries.some(
        entry => entry.isIntersecting || entry.intersectionRatio > 0
      )

      if (hasVisibleEntry) {
        setIsVisible(true)
        observer.disconnect()
      }
    }, { rootMargin })

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => observer.disconnect()
  }, [rootMargin])

  const resolvedMinHeight =
    typeof minHeight === "number" ? `${minHeight}px` : minHeight

  return (
    <div
      ref={containerRef}
      className={className}
      style={resolvedMinHeight ? { minHeight: resolvedMinHeight } : undefined}
    >
      {isVisible ? children : placeholder}
    </div>
  )
}

export default LazyRenderOnView
